var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 21.6C17.302 21.6 21.6 17.302 21.6 12C21.6 6.69809 17.302 2.40002 12 2.40002C6.69809 2.40002 2.40002 6.69809 2.40002 12C2.40002 17.302 6.69809 21.6 12 21.6ZM11.4657 8.60157C11.0974 8.35608 10.624 8.33319 10.2338 8.54202C9.84361 8.75084 9.60002 9.15747 9.60002 9.60003V14.4C9.60002 14.8426 9.84361 15.2492 10.2338 15.458C10.624 15.6669 11.0974 15.644 11.4657 15.3985L15.0657 12.9985C15.3995 12.7759 15.6 12.4012 15.6 12C15.6 11.5988 15.3995 11.2241 15.0657 11.0016L11.4657 8.60157Z",
    fill: "#292A3A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlay);
export default __webpack_public_path__ + "static/media/play.5d10cdfbb57413615d72d51a99408c7f.svg";
export { ForwardRef as ReactComponent };